<template>
  <div>
    <div class="row mt-4">
      <div class="col-md-6 col-lg-3 col-xl-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.activity') }} *</label>
          <el-select
            @change="changeActivity(true)"
            filterable
            class="select-primary custom-width-select shadow-sm required-activity"
            size="large"
            v-model="model.activity_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in activities"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 col-xl-3">
        <fg-input
          :label="`${$t('labor.unit_value_dollarsign')}: *`"
          v-model="model.price"
          type="number"
          v-validate="modelValidations.price"
          name="common_words.value_activity"
          :error="getError('common_words.value_activity', true)"
          placeholder="38000..."
        ></fg-input>
      </div>
      <div class="col-md-6 col-lg-3 col-xl-2">
        <fg-input
          :label="`${$t('labor.unit_of_payment')}: `"
          readonly
          v-model="selectedActivity.unit_production_name"
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-md-6 col-lg-3 col-xl-3">
        <fg-input
          :label="`${$t('common_words.category')}: `"
          readonly
          v-model="selectedActivity.group_name"
          placeholder="..."
        ></fg-input>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-4 col-lg-3 col-xl-2">
        <label>
          {{ $t('labor.hours_extra') }}?
          <el-checkbox
            class="pl-2 mb-0"
            v-model="model.extra_hours"
            @change="changeExtraHours(true)"
          ></el-checkbox>
        </label>
        <br />
        <fg-input
          min="0"
          max="12"
          class="shadow-sm required-number-extra-hours"
          type="number"
          v-model="model.number_extra_hours"
          v-validate="modelValidations.number_extra_hours"
          name="labor.hours_extra"
          :error="getError('labor.hours_extra', true)"
          placeholder=" ..."
          :disabled="model.extra_hours ? false : true"
        >
        </fg-input>
      </div>
      <div class="col-md-4 col-lg-5 col-xl-2">
        <div class="form-group has-label">
          <label>{{ $t('common_words.starting_date') }}: *</label>
          <br />
          <el-date-picker
            v-if="renderComponent"
            class="shadow-sm required-dates"
            v-model="model.start_date"
            type="date"
            :picker-options="pickerOptions"
            range-separator="-"
            :placeholder="`${$t('common_words.select2')}...`"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-2">
        <div class="form-group has-label">
          <label>{{ $t('common_words.type') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary mb-3 shadow-sm required-type"
            v-model="model.type"
            :placeholder="`${$t('common_words.select2')}...`"
            @change="handleChangeTypes"
            @clear="model.type = null"
          >
            <el-option
              class="select-primary"
              v-for="item in optionsType"
              :key="item.id + item.value"
              :label="item.value"
              :value="item.id"
              :disabled="
                item.id === 'lote' && selectedActivity.catch_type !== 'lote'
              "
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="this.model.type" :class="getClassBusinesses">
        <div class="form-group has-label">
          <label>{{ $t('common_words.company') }}: *</label>
          <br />
          <el-select
            collapse-tags
            @change="handleChangeBusinesses"
            @clear="
              model.rate_businesses_id = [];
              handleChangeBusinesses();
            "
            clearable
            multiple
            filterable
            class="select-primary shadow-sm required-businesses"
            size="large"
            v-model="model.businesses_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div
        :class="getClassFarms"
        v-if="
          model.businesses_id.length > 0 &&
          (model.type === 'finca' || model.type === 'lote')
        "
      >
        <div class="form-group has-label">
          <label>{{ $t('common_words.farm') }}: *</label>
          <br />
          <el-select
            clearable
            multiple
            collapse-tags
            filterable
            @change="handleChangeFarms"
            @clear="handleChangeFarms"
            class="select-primary custom-width-select shadow-sm required-farms"
            size="large"
            v-model="model.farms_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="(option, index) in listFarmsByBusiness"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="index + '' + option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div
        class="col-md-12 col-lg-4 col-xl-6"
        v-if="
          model.businesses_id.length > 0 &&
          model.farms_id.length > 0 &&
          model.type === 'lote' &&
          selectedActivity.catch_type === 'lote'
        "
      >
        <div class="form-group has-label">
          <label>{{ $t('common_words.allotment') }}: *</label>
          <br />
          <el-select
            collapse-tags
            @change="handleChangeLots"
            @clear="handleChangeLots"
            clearable
            filterable
            multiple
            class="select-primary custom-width-select shadow-sm required-lots"
            size="large"
            v-model="model.lots_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="(option, index) in lots"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="index + '' + option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <hr />
    <div v-if="isSelectedType">
      <el-checkbox style="z-index: 101" v-model="checked">{{
        $t('labor.rate_additional')
      }}</el-checkbox>
    </div>
    <div v-if="checked" class="sticky-row">
      <div class="row px-0 text-center">
        <div class="col-12">
          <div class="d-flex justify-content-start float-right">
            <el-button
              :v-tooltip.top-left="$t('labor.rate_add')"
              class="btn-info button-new-tag"
              size="small"
              icon="el-icon-plus"
              :disabled="amountBusiness()"
              @click="addRate()"
            >
            </el-button>
            <el-button
              v-if="rateNumber > 1"
              v-tooltip.top-left="$t('labor.rate_delete')"
              class="btn-info button-new-tag"
              size="small"
              icon="el-icon-minus"
              @click="reduceRate()"
            >
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <br />
    <template v-if="isSelectedType">
      <div v-for="index in rateNumber" :key="index">
        <div
          v-if="checked"
          class="row py-3 mb-4 shadow-sm"
          style="border: 0.5px solid #6ba6524d"
        >
          <div v-if="checked" :class="getClassRate">
            <div class="form-group has-label form-custom-group">
              <label class="col-text-ellipsis"
                >{{ $t('labor.rate_type') }}:
              </label>
              <br />
              <el-select
                collapse-tags
                clearable
                filterable
                class="select-primary custom-width-select shadow-sm required-rate"
                size="large"
                v-model="model.rate_types_id[index - 1]"
                :placeholder="`${$t('common_words.select')}...`"
                @change="handleChangeRates(index - 1)"
                @clear="handleChangeRates(index - 1)"
              >
                <el-option
                  v-for="option in filteredActivityrates"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div v-if="checked" :class="getClassValueRate">
            <div class="form-group has-label form-custom-group">
              <label
                class="col-text-ellipsis"
                :v-tooltip.bottom="$t('common_words.increment_selected_value')"
                >{{ $t('common_words.increment') }} ($):
              </label>
              <br />
              <fg-input
                type="number"
                v-model.number="model.rate_values[index - 1]"
                v-validate="modelValidations.rate_values"
                name="common_words.increment_rate_row"
                :error="
                  getError('common_words.increment_rate_row', true, index)
                "
                :placeholder="`${$t('common_words.value')}...`"
              ></fg-input>
            </div>
          </div>
          <div
            v-if="
              (checked && model.type === 'empresa') ||
              (checked && model.type === 'finca') ||
              (checked && model.type === 'lote')
            "
            :class="getClassBusinessRate"
          >
            <div class="form-group has-label form-custom-group">
              <label class="col-text-ellipsis"
                >{{ $t('common_words.associate_a_company') }}:
              </label>
              <br />
              <el-select
                collapse-tags
                clearable
                filterable
                class="select-primary custom-width-select shadow-sm required-rate-business"
                size="large"
                v-model="model.rate_businesses_id[index - 1]"
                :placeholder="`${$t('common_words.select')}...`"
                @change="handleChangeRateBusinesses(index - 1)"
                @clear="handleChangeRateBusinesses(index - 1)"
              >
                <el-option
                  v-for="(option, index) in businessFiltered"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="index + '' + option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            v-if="
              (checked && model.type === 'finca') ||
              (checked && model.type === 'lote')
            "
            :class="getClassFarmRate"
          >
            <div class="form-group has-label form-custom-group">
              <label style="margin-bottom: 12px"
                >{{ $t('common_words.associate_a_farm') }}:
              </label>
              <br />
              <el-select
                collapse-tags
                clearable
                filterable
                class="select-primary custom-width-select shadow-sm required-rate-farms"
                size="large"
                v-model="model.rate_farms_id[index - 1]"
                :placeholder="`${$t('common_words.select')}...`"
                @change="handleChangeRateFarms(index - 1)"
                @clear="handleChangeRateFarms(index - 1)"
              >
                <el-option
                  v-for="(option, index) in farmFilter(index - 1)"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="index + '' + option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            v-if="
              checked &&
              model.type === 'lote' &&
              selectedActivity.catch_type === 'lote'
            "
            class="col-sm-12 col-md-6 col-xl-3"
          >
            <div class="form-group has-label form-custom-group">
              <label style="margin-bottom: 12px"
                >{{ $t('common_words.associate_a_allotment') }}:
              </label>
              <br />
              <el-select
                collapse-tags
                clearable
                filterable
                class="select-primary custom-width-select shadow-sm required-rate-lots"
                size="large"
                v-model="model.rate_lots_id[index - 1]"
                :placeholder="`${$t('common_words.select')}...`"
                @change="handleChangeRateLots(index - 1)"
                @clear="handleChangeRateLots(index - 1)"
              >
                <el-option
                  v-for="(option, index) in lotFilter(index - 1)"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="index + '' + option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import i18n from 'src/i18n';
import MixinFarm from 'src/util/mixinFarm';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinHandle from './mixin-handle-first-step';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';
import MixinRender from 'src/mixins/mixin-rerender.js';

export default {
  components: {
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup,
  },
  data() {
    return {
      activities: [],
      activityrates: [],
      activityUnit: [],
      amountAvalible: [1, 1],
      businesses: [],
      checked: false,
      count: 0,
      farms: [],
      lots: [],
      radio: [],
      rateNumber: 1,
      timeTypes: [],
      model: {
        activity_id: null,
        businesses_id: [],
        rate_businesses_id: [],
        extra_hours: 0,
        number_extra_hours: null,
        farms_id: [],
        price: null,
        rate_farms_id: [],
        lots_id: [],
        rate_lots_id: [],
        rate_types_id: [],
        rate_values: [],
        relation_rates: [],
        rate_type_delete: [],
        start_date: null,
        type: null,
      },
      modelValidations: {
        rate_values: {
          required: true,
        },
        price: {
          required: true,
        },
        number_extra_hours: {
          required:
            this.model && this.model.extra_hours
              ? this.model.extra_hours
              : false,
          min_value: 0,
          max_value: 12,
        },
      },
      optionsType: [
        { id: 'empresa', value: 'Empresa' },
        { id: 'finca', value: 'Finca' },
        {
          id: 'lote',
          value: 'Lote',
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);

          return time.getTime() < currentDate.getTime();
        },
      },
      selectedActivity: {
        activityUnitName: null,
        catch_type: 'finca',
      },
    };
  },
  mixins: [
    MixinPermissions,
    MixinFarm,
    MixinHandle,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
    MixinRender,
  ],
  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },
  computed: {
    isSelectedType() {
      if (this.model.type) {
        return ['empresa', 'finca', 'lote'].includes(this.model.type);
      }

      return false;
    },

    getClassRate() {
      const typeToClassMap = {
        empresa: 'col-md-6 col-lg-4',
        finca: 'col-lg-6 col-xl-3',
        lote: 'col-lg-4 col-xl-2',
      };

      return `col-sm-6 ${typeToClassMap[this.model.type] || 'col-xl-2'}`;
    },

    getClassValueRate() {
      const typeToClassMap = {
        empresa: 'col-md-6 col-lg-4',
        finca: 'col-lg-6 col-xl-3',
        lote: 'col-lg-3 col-xl-2',
      };

      return `col-sm-6 ${typeToClassMap[this.model.type] || 'col-xl-2'}`;
    },

    getClassBusinessRate() {
      const typeToClassMap = {
        empresa: 'col-sm-12 col-lg-4',
        finca: 'col-sm-6 col-xl-3',
        lote: 'col-md-6 col-lg-5 col-xl-2',
      };

      return `${typeToClassMap[this.model.type] || 'col-xl-2'}`;
    },

    getClassFarmRate() {
      const typeToClassMap = {
        finca: 'col-sm-6 col-xl-3',
        lote: 'col-md-6 col-lg-6 col-xl-3',
      };

      return `${
        typeToClassMap[this.model.type] || 'col-md-6 col-lg-4 col-xl-2'
      }`;
    },

    getClassBusinesses() {
      const typeToClassMap = {
        empresa: 'col-md-12 col-lg-12 col-xl-6',
        finca: 'col-md-6 col-xl-3',
        lote: 'col-md-6 col-lg-4 col-xl-6',
      };

      return `${typeToClassMap[this.model.type] || 'col-xl-3'}`;
    },

    getClassFarms() {
      const isLoteType = this.model.type === 'lote';
      return `col-md-6 ${isLoteType ? 'col-lg-4 col-xl-6' : 'col-xl-3'}`;
    },

    listFarmsByBusiness() {
      const filtered = this.farms.filter((farm) => {
        return (
          farm.businesses &&
          farm.businesses.some((item) =>
            this.model.businesses_id.includes(item.id)
          )
        );
      });

      return this.concatAll(filtered);
    },

    businessFiltered() {
      return this.getDataByOtherSelected(
        this.businesses,
        this.model.rate_businesses_id,
        this.model.businesses_id
      );
    },

    filteredActivityrates() {
      return this.getDataByOtherSelected(
        this.activityrates,
        this.model.rate_types_id,
        null,
        [true, 0]
      );
    },
  },

  methods: {
    changeExtraHours() {
      this.modelValidations.number_extra_hours = {
        ...this.modelValidations.number_extra_hours,
        required: this.model.extra_hours,
      };
    },
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
      this.lots = this.concatAll(this.lots.splice(1));
    },

    calculateAmountAvalible() {
      let amounts = null;
      switch (this.model.type) {
        case 'empresa':
          this.amountAvalible[0] = this.numberBusinesses();
          amounts = this.model.businesses_id.reduce((acc, id) => {
            return {
              ...acc,
              [id]: this.numberRates(),
            };
          }, {});

          this.amountAvalible[1] = amounts;
          break;
        case 'finca':
          amounts = this.model.businesses_id
            .map((businessId) => {
              const len = this.farms.filter((farm) =>
                farm.businesses.some((item) => businessId === item.id)
              ).length;

              return {
                [businessId]: this.numberRates() * len,
              };
            })
            .reduce((acc, id) => {
              return {
                ...acc,
                ...id,
              };
            }, {});

          this.amountAvalible[0] = this.numberFarms();
          this.amountAvalible[1] = amounts;
          break;

        default:
          this.amountAvalible[0] = this.numberLots();
          amounts = this.model.businesses_id
            .map((businessId) => {
              const listFarms = this.farms.filter((farm) =>
                farm.businesses.some((item) => businessId === item.id)
              );
              const len = listFarms
                .map((farm) => {
                  const lots = farm.lots.filter((lot) =>
                    this.model.lots_id.includes(lot.id)
                  );
                  return lots.length;
                })
                .reduce((acc, len) => acc + len, 0);

              return {
                [businessId]: this.numberRates() * listFarms.length * len,
              };
            })
            .reduce((acc, id) => {
              return {
                ...acc,
                ...id,
              };
            }, {});

          this.amountAvalible[1] = amounts;
          break;
      }
    },

    farmFilter(index) {
      return this.getDataByOtherSelected(
        this.farms,
        this.model.rate_farms_id,
        this.model.farms_id,
        [false, 'farm', this.model.rate_businesses_id[index]],
        this.model.type === 'finca'
          ? this.numberRates()
          : this.numberRates() * this.numberLots()
      );
    },

    lotFilter(index) {
      return this.lots.filter((lot) => {
        return (
          this.model.lots_id.includes(lot.id) &&
          lot.farm_id === this.model.rate_farms_id[index]
        );
      });
    },

    validateRepeatRates(index, type) {
      try {
        const currentValue = this.model.relation_rates[index].split('-');
        const validate = this.model.relation_rates.some((relations, i) => {
          if (i !== index) {
            const [type, business, farm, lot] = relations.split('-');
            const isSameType = type === currentValue[0];
            const isSameBusiness = business === currentValue[1];
            const isSameFarm = farm === currentValue[2];
            const isSameLot = lot === currentValue[3];

            if (this.model.type === 'empresa' && isSameType && isSameBusiness)
              return true;
            else if (
              this.model.type === 'finca' &&
              isSameType &&
              isSameBusiness &&
              isSameFarm
            ) {
              return true;
            } else if (
              this.model.type === 'lote' &&
              isSameType &&
              isSameBusiness &&
              isSameFarm &&
              isSameLot
            ) {
              return true;
            }
          }
          return false;
        });

        if (validate) {
          const rate = this.activityrates.find(
            (rate) => rate.id === Number(currentValue[0])
          );
          const business = this.businesses.find(
            (business) => business.id === Number(currentValue[1])
          );
          let msg = '';
          let farm = null;

          try {
            farm = this.farms.find(
              (farm) => farm.id === Number(currentValue[2])
            );
          } catch (error) {
            //
          }

          switch (this.model.type) {
            case 'empresa':
              msg = `${i18n.t(message.msg.rate_msg)} "${rate.name}" ${i18n.t(
                message.msg.company_msg
              )}"${business.name}"
              ${i18n.t(message.msg.selected_msg)}.`;
              break;
            case 'finca':
              msg = `${i18n.t(message.msg.rate_msg)}  "${rate.name}", ${i18n.t(
                message.msg.company_msg
              )}"${business.name}"
              ${i18n.t(message.msg.farm_msg)} "${farm.name}" ${i18n.t(
                message.msg.selected_msg
              )}.`;
              break;
            default:
              const filteredLots = this.lots.filter((lot) => {
                return this.model.lots_id.includes(lot.id);
              });

              const lot = filteredLots.find(
                (lot) => lot.id === Number(currentValue[3])
              );

              msg = `${i18n.t(message.msg.rate_msg)}  "${rate.name}", ${i18n.t(
                message.msg.company_msg
              )} "${business.name}",
              ${i18n.t(message.msg.farm_msg)}"${farm.name}" ${i18n.t(
                message.msg.allotment_msg
              )} "${lot.name}" ${i18n.t(message.msg.selected_msg)}.`;
              break;
          }

          SweetAlert.warning(msg);
          let temp = [];

          switch (type) {
            case 'rate_types_id':
              temp = [...this.model.rate_types_id];
              delete temp[index];
              break;
            case 'rate_businesses_id':
              temp = [...this.model.rate_businesses_id];
              delete temp[index];
              break;
            case 'rate_farms_id':
              temp = [...this.model.rate_farms_id];
              delete temp[index];
              break;
            default:
              temp = [...this.model.rate_lots_id];
              delete temp[index];
              break;
          }

          this.$set(this.model, type, temp);
          this.handleChange(index, type);
        }
      } catch (error) {
        // code
      }
    },

    handleChange(index, field) {
      let splited = null;
      if (this.model.relation_rates[index]) {
        splited = this.model.relation_rates[index].split('-');
      } else {
        splited = ['rate', 'business', 'farm', 'lot'];
      }

      switch (field) {
        case 'rate_types_id':
          splited[0] = this.model.rate_types_id[index];
          break;
        case 'rate_businesses_id':
          splited[1] = this.model.rate_businesses_id[index];
          break;
        case 'rate_farms_id':
          splited[2] = this.model.rate_farms_id[index];
          break;
        default:
          splited[3] = this.model.rate_lots_id[index];
          break;
      }

      this.$set(this.model.relation_rates, index, splited.join('-'));
    },

    opty(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },

    addRate() {
      return this.rateNumber++;
    },

    reduceRate() {
      if (this.rateNumber > 0) {
        const index = this.rateNumber - 1;
        this.rateNumber--;
        this.count--;
        if (this.isSelectedType) {
          this.model.rate_types_id.splice(index, 1);
          this.model.rate_values.splice(index, 1);
          this.model.rate_businesses_id.splice(index, 1);
          this.model.rate_farms_id.splice(index, 1);
          this.model.rate_lots_id.splice(index, 1);
          this.model.relation_rates.splice(index, 1);
        }
      }
    },

    clearAll() {
      this.model.rate_types_id = [];
      this.model.rate_values = [];
      this.model.rate_businesses_id = [];
      this.model.rate_farms_id = [];
      this.model.rate_lots_id = [];
    },

    cleaRows() {
      let removedId = [];
      switch (this.model.type) {
        case 'empresa':
          if (!isset(this.model.businesses_id)) this.clearAll();
          else {
            removedId = this.getRemovedId(
              this.model.rate_businesses_id,
              this.model.businesses_id
            );

            this.cleanRateTypes(removedId, this.model.rate_businesses_id, [
              'rate_types_id',
              'rate_businesses_id',
            ]);

            this.model.rate_farms_id = [];
            this.model.rate_lots_id = [];
          }
          break;
        case 'finca':
          if (!isset(this.model.farms_id)) {
            this.model.rate_types_id = [];
            this.model.rate_farms_id = [];
          } else {
            removedId = this.getRemovedId(
              this.model.rate_farms_id,
              this.model.farms_id
            );
            this.cleanRateTypes(removedId, this.model.rate_farms_id, [
              'rate_types_id',
              'rate_businesses_id',
              'rate_farms_id',
            ]);
          }
          break;
        case 'lote':
          if (!isset(this.model.lots_id)) {
            this.model.rate_types_id = [];
            this.model.rate_farms_id = [];
            this.model.rate_lots_id = [];
          } else {
            removedId = this.getRemovedId(
              this.model.rate_lots_id,
              this.model.lots_id
            );
            this.cleanRateTypes(removedId, this.model.rate_lots_id, [
              'rate_types_id',
              'rate_businesses_id',
              'rate_farms_id',
              'rate_lots_id',
            ]);
          }
          break;

        default:
          break;
      }
    },

    amountBusiness() {
      if (this.rateNumber > 10) {
        return true;
      }
    },

    numberBusinesses() {
      return this.model.businesses_id.length;
    },

    numberFarms() {
      return this.model.farms_id.length;
    },

    numberLots() {
      return this.model.lots_id.length;
    },

    numberRates() {
      return this.activityrates.length;
    },

    async validate() {
      return this.$validator
        .validateAll()
        .then(async (res) => {
          if (!res) return res;

          if (!isset(this.model.activity_id)) {
            return this.validationInputsRequired('activity');
          } else if (!isset(this.model.start_date)) {
            return this.validationInputsRequired('dates');
          } else if (
            Number(this.model.extra_hours) !== null &&
            ![0, 1].includes(Number(this.model.extra_hours))
          ) {
            return this.validationInputsRequired('extra-hours');
          } else if (!isset(this.model.type)) {
            return this.validationInputsRequired('type');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('businesses');
          } else if (
            ['lote', 'finca'].includes(this.model.type) &&
            !isset(this.model.farms_id)
          ) {
            return this.validationInputsRequired('farms');
          } else if (this.model.type === 'lote' && !isset(this.model.lots_id)) {
            return this.validationInputsRequired('lots');
          } else if (this.checked) {
            let modelToValidate = [
              this.model.rate_types_id,
              this.model.rate_businesses_id,
            ];

            if (this.model.type === 'finca') {
              modelToValidate = [
                ...modelToValidate,
                ...[this.model.rate_farms_id],
              ];
            } else if (this.model.type === 'lote') {
              modelToValidate = [
                ...modelToValidate,
                ...[this.model.rate_farms_id, this.model.rate_lots_id],
              ];
            }

            const response = await this.validateVariousSelect(
              this.rateNumber,
              modelToValidate,
              ['rate', 'rate-business', 'rate-farms', 'rate-lots']
            ).then((passed) => passed.every((pass) => pass));

            return response;
          } else return res;
        })
        .then((res) => {
          const activitySelected = this.activities.find(
            (item) => item.id === this.model.activity_id
          );

          this.$emit('on-validated', {
            ...this.model,
            activityName: activitySelected.name,
            unitProductionName: activitySelected.unit_production_name,
            groupName: activitySelected.group_name,
            typeName: this.optionsType.find(
              (item) => item.id === this.model.type
            ).value,
            businessesNames: this.opty(
              this.model.businesses_id,
              this.businesses
            ),
            farmsNames: this.opty(this.model.farms_id, this.farms),
            lotsNames: this.opty(this.model.lots_id, this.lots),

            rate_types: this.checked
              ? this.model.rate_types_id.map((id, index) => {
                  return {
                    activity_rate: this.activityrates.find(
                      (rate) => rate.id === id
                    ),
                    rate_value: Number(this.model.rate_values[index]),
                    business: {
                      name: this.businesses.find(
                        (business) =>
                          business.id === this.model.rate_businesses_id[index]
                      ).name,
                    },
                    farm:
                      this.model.type === 'empresa'
                        ? null
                        : {
                            name: this.farms.find(
                              (farm) =>
                                farm.id === this.model.rate_farms_id[index]
                            ).name,
                          },
                    lot: ['empresa', 'finca'].includes(this.model.type)
                      ? null
                      : {
                          name: this.lots.find(
                            (lot) => lot.id === this.model.rate_lots_id[index]
                          ).name,
                        },
                  };
                })
              : [],
          });

          return res;
        });
    },

    async getLots() {
      if (this.model.type === 'lote') {
        this.showHideLoading(true);
        const allLots = await this.getLotsByFarm(
          this.model.farms_id,
          this.farms
        );
        this.lots = this.concatAll(allLots);
        this.showHideLoading();
      }
    },

    changeActivity(history = true) {
      this.selectedActivity = this.activities.find(
        (element) => element.id === this.model.activity_id
      );

      if (
        !sessionStorage.getItem('editForm') &&
        history &&
        this.selectedActivity.history
      ) {
        SweetAlert.default(
          `${i18n.t('sweet_alert.jobs.historic_copy_msg')}`,
          `${i18n.t('sweet_alert.jobs.record_in_existance_msg')} "${
            this.selectedActivity.name
          }", 
          ${i18n.t('sweet_alert.jobs.upload_necessary_data_msg')}`,
          i18n.t('sweet_alert.jobs.load_data_msg')
        ).then((resp) => {
          if (resp.value) {
            const editForm = { ...this.selectedActivity.history };
            editForm.rateNumber =
              this.selectedActivity.history.rate_types.length;
            this.loadToUpdate(editForm, false);
            this.$emit('updateInSecondStep', editForm);

            if (editForm.start_date) {
              this.pickerOptions.disabledDate = (time) => {
                const currentDate = new Date(editForm.start_date);
                currentDate.setHours(0, 0, 0, 0);

                const theNextDay = new Date(editForm.start_date);
                theNextDay.setDate(currentDate.getDate() + 1);
                theNextDay.setHours(0, 0, 0, 0);

                return time.getTime() <= theNextDay.getTime();
              };
            }
          }
        });
      }
    },

    loadToUpdate(editForm, toChangeActivity) {
      this.model = {
        ...this.model,
        ...editForm,
        extra_hours: Number(editForm.extra_hours) === 1,
        number_extra_hours:
          Number(editForm.number_extra_hours) == 0
            ? null
            : editForm.number_extra_hours,
      };
      this.model.start_date = moment(this.model.start_date);
      this.model.rate_type_delete = [];
      if (this.model.rateNumber) {
        this.rateNumber = this.model.rateNumber;
        this.checked = true;
      }
      if (toChangeActivity) this.changeActivity(false);
      this.getLots();
      this.calculateAmountAvalible();

      setTimeout(() => {
        this.model.rate_types.forEach((rate, index) => {
          this.model.rate_types_id.push(rate.activity_rate_id);
          this.model.rate_values.push(Number(rate.rate_value));
          this.model.rate_businesses_id.push(rate.business_id);
          this.model.rate_farms_id.push(rate.farm_id);
          this.model.rate_lots_id.push(rate.lot_id);
          this.handleChange(index, 'rate_types_id');
          this.handleChange(index, 'rate_businesses_id');
          this.handleChange(index, 'rate_farms_id');
          this.handleChange(index, 'rate_lots_id');
        });
      }, 100);
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('works/activities/field'),
        Axios.getMasters('businesses/only'),
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('works/activityrates/field'),
      ])
        .then((response) => {
          const [
            response_activities,
            response_businesess,
            response_farms,
            response_activityrates,
          ] = response;
          this.activities = response_activities.data.data;
          this.businesses = this.concatAll(response_businesess.data.data);
          this.farms = response_farms.data.data;
          this.activityrates = response_activityrates.data.data;

          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            const editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.loadToUpdate(editForm, true);
          }

          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
<style scoped>
.sticky-row {
  position: sticky;
  z-index: 100;
  top: 0;
  padding-top: 20px;
  margin-top: -50px;
}
.custom-checkbox {
  position: absolute;
  bottom: 11px;
}
</style>
